define('shared/util/phoneDetector',[
], function() {
    'use strict';

    var ua = navigator.userAgent;
    var device = {};
    device.Android = /Android/i.test(ua) && !navigator.msSaveBlob;
    device.iPhone = /iPhone|iPad|iPod/i.test(ua) && !navigator.msSaveBlob;

    return device;
});
